<template>
    <div class="h-full mt-36 items-center justify-center relative">
        <h1
            class="font-gilroy-extrabold text-black relative z-30 text-5xl text-center"
            data-aos="fade-down"
            data-aos-duration="1500"
        > Sky-rocket your business.<br>Schedule a call!</h1>

        <div class="mt-16 px-3 grid grid-cols-1 md:grid-cols-2 md:gap-4">
            <div
                class="h-full relative rounded-lg md:rounded-r-lg"
                data-aos="fade-right"
                data-aos-duration="1000"
            >

                <div class="absolute text-center md:text-left w-full md:w-96 z-30 px-16 py-10">
                    <h1
                        class="font-gilroy-extrabold text-white text-6xl"
                        data-aos="fade-right"
                        data-aos-duration="1500"
                    > Focsani </h1>

                    <span
                        class="mt-5 text-inter-500 block text-xl text-gray-200"
                        data-aos="fade-right"
                        data-aos-duration="2000"
                    >9 Unirii Blvd.</span>
                    <span
                        class="text-inter-500 block text-xl text-gray-200"
                        data-aos="fade-right"
                        data-aos-duration="2500"
                    >Focsani, Vrancea</span>
                    <span
                        class="text-inter-500 block text-xl text-gray-200"
                        data-aos="fade-right"
                        data-aos-duration="3000"
                    >contact@codestage.ro</span>

                    <router-link
                        data-aos="fade-right"
                        data-aos-duration="2500"
                        to="/contact"
                        class="mt-6 block relative w-56 mx-auto md:ml-0 z-30 bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 transition transform duration-500 text-white text-center text-sm rounded-md py-3 px-8 aos-init aos-animate"
                    >Schedule a call</router-link>
                </div>

                <div class="absolute opacity-75 rounded-lg md:rounded-r-lg bg-gradient-to-br from-blue-500 to-purple-600 w-full h-full"></div>

                <div
                    class="h-80 bg-cover rounded-lg md:rounded-r-lg"
                    style="background-image: url('images/assets/focsani.png')"
                ></div>
            </div>
            <div class="h-3 md:hidden"></div>
            <div
                class="h-full relative rounded-lg md:rounded-l-lg"
                data-aos="fade-left"
                data-aos-duration="1000"
            >

                <div class="absolute z-30  text-center md:text-right w-full md:w-96 md:right-10 right-0 px-10 py-10">
                    <h1
                        class="font-gilroy-extrabold text-white text-6xl"
                        data-aos="fade-left"
                        data-aos-duration="1500"
                    > Bucharest </h1>

                    <span
                        class="mt-5 text-inter-500 block text-xl text-gray-200"
                        data-aos="fade-left"
                        data-aos-duration="2000"
                    >76 Unirii Blvd.</span>
                    <span
                        class="text-inter-500 block text-xl text-gray-200"
                        data-aos="fade-left"
                        data-aos-duration="2500"
                    >District 3, Bucharest</span>
                    <span
                        class="text-inter-500 block text-xl text-gray-200"
                        data-aos="fade-left"
                        data-aos-duration="3000"
                    >contact@codestage.ro</span>

                    <router-link
                        data-aos="fade-left"
                        data-aos-duration="3000"
                        to="/contact"
                        class="mt-6 block relative float-none mx-auto md:float-right w-56 z-30 bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 transition transform duration-500 text-white text-center text-sm rounded-md py-3 px-2 aos-init aos-animate"
                    >Schedule a call</router-link>
                </div>

                <div class="absolute opacity-75 rounded-lg md:rounded-l-lg bg-gradient-to-bl from-blue-500 to-purple-600 w-full h-full"></div>

                <div
                    class="h-80 bg-cover rounded-lg md:rounded-l-lg"
                    style="background-image: url('images/assets/bucharest.png')"
                ></div>
            </div>
        </div>
        <div class="absolute bg-white rounded-full p-6 -ml-20 -mt-8 left-2/4 top-2/4 h-40 w-40 hidden md:block">
            <img
                class="w-12/12"
                src="images/logos/logo_color.png"
            >
        </div>
    </div>
</template>

<script>
export default {

}
</script>